// https://developer.mozilla.org/en-US/docs/Web/Events
export enum WindowEventType {
	resize = 'resize',
}

export const ACCEPTED_WINDOW_EVENT_TYPES: WindowEventType[] = [WindowEventType.resize];
